import React, { useEffect, useState } from "react";
import NightMode from "../NightMode/BlackTheme";
import Header from "../header/Header";
import SubLinks from "../navlinks/SubLinks";
import { getAskLunaView, saveAskLunaView } from "../../apiclients/streamsapi_bridge";
function Body(props) {
  const [mclassName, setMClassName] = useState("page-content");
  const [hideSubmenu, setHideSubmenu] = useState(false);

  function onToggleLP(toggle) {
    console.log("in header call backe.. " + toggle)
    if (toggle) {
      setMClassName("container-fluid toggled");
      setHideSubmenu(true);
    } else {
      setMClassName("container-fluid");
      setHideSubmenu(false);
    }
    console.log("hideS.. bmenu :: " + hideSubmenu)
  }

  useEffect(() => {
    console.log("hideSuin effect.. bmenu :: " + hideSubmenu)
  }, [])

  const [docked, setDocked] = useState(false);
  const [opendocked, setOpenDocked] = useState(false);

  const getALView = async () => {
   const adminSession = sessionStorage.getItem("admin_session");
   const siteid = adminSession ? JSON.parse(adminSession)?.siteid : null;
   if (!siteid) {
     console.warn("Site ID not found in session.");
     fallbackToSessionValues();
     return;
   }
   try {
       const response = await getAskLunaView(siteid);    
       const  respData  = await response.json();
       const asklunaview = respData.asklunaview;
       console.log("AskLunaView1111 2222response:", asklunaview);
       if(asklunaview === undefined || asklunaview === null){
         console.warn("AskLunaView is undefined or null, falling back to session values.");
         fallbackToSessionValues();
         return;
       }
       const open = asklunaview*1 !== 0;
       const docked = asklunaview*1 === 2;
   
       setOpenDocked(open);
       setDocked(docked);
     } catch (error) {
       console.error("getALView failed:", error);
       fallbackToSessionValues();
     }
 };

  const fallbackToSessionValues = () => {
    setDocked(sessionStorage.getItem("chatbotDocked") === "true");
    setOpenDocked(sessionStorage.getItem("chatbotOpen") === "true");
  };

  useEffect(() => {
    getALView();
  }, []);


  return (
    <>
      <header>
        <div className="d-none" >
          <NightMode />
        </div>
        <Header active={props.tablinks} onToggleLP={onToggleLP} isopen={opendocked}    setDocked={setDocked} setOpenDocked={setOpenDocked}/>
        <SubLinks tablinkid={props.tablinks} slinkid={props.sublink} active={props.tablinks} hideSubmenu={hideSubmenu} />
      </header>
      <main className={mclassName} id="page-content">
        <div className={docked && opendocked ? "chatbot-viewadjust" : ""}>{props.content}</div>
      </main>
    </>
  );
}

export default Body;
